/**
 * Gesamtwerte des v2-Speicherformulars.
 *
 * Alle Speicher-Einzelwerte (nutzbare Kapazität, Lade-, Entlade- und Wechselrichterleistung)
 * werden pro **Speichersystem** erfasst. Die im Formular und im Inbetriebsetzungsprotokoll
 * angezeigten Gesamtwerte sind deshalb immer `Anzahl × Einzelwert`.
 *
 * Genutzt von `StorageFormpartV2Component` (Summenzeilen unter den Eingaben) und von
 * `GrPlaceInServiceStorageRequestFormComponent` (Karte „Netzanmeldung“).
 */

/**
 * Produkt zweier Formularwerte.
 *
 * @returns `null`, sobald einer der Werte fehlt (`null`/`undefined`/Leerstring) oder nicht
 *   numerisch ist — die Oberfläche zeigt dann „keine Angabe“ statt einer irreführenden `0`.
 */
export function storageTotal(count: unknown, valuePerStorage: unknown): number | null {
  if (count == null || valuePerStorage == null || count === '' || valuePerStorage === '') {
    return null;
  }
  const numericCount = Number(count);
  const numericValue = Number(valuePerStorage);
  if (Number.isNaN(numericCount) || Number.isNaN(numericValue)) {
    return null;
  }
  return numericCount * numericValue;
}

/** Ab dieser Gesamt-Wechselrichterleistung (kW) greift der §14a-EnWG-Prozess für den Speicher. */
export const STORAGE_P14A_POWER_THRESHOLD_KW = 4.2;
